// src/components/Insurance.tsx
import { Box, Button, Card, CardContent, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

const insurances = [
  { type: 'Basic', cost: '$2', coverage: 'Protect up to $1,000' },
  { type: 'Premium', cost: '$5', coverage: 'Protect up to $10,000' },
];

export default function Insurance() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{
      background: 'background.default',
      backgroundImage: 'url(images/background.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat', 
      textAlign: 'center',
      py: { xs: 4, sm: 6 },
      px: { xs: 2, sm: 3, md: 4 },
      width: '100%',
    }}>
      <Grid 
        container 
        spacing={{ xs: 2, sm: 3, md: 4 }} 
        justifyContent="center" 
        sx={{ 
          mt: { xs: 2, sm: 3 }, 
          maxWidth: 1200, 
          mx: 'auto', 
          p: { xs: 2, sm: 3, md: 4 }, 
          borderRadius: 5, 
          boxShadow: 3, 
          bgcolor: '#20272D' 
        }} 
        component={Box}
      >
        <Grid size={{xs:12}}>
          <Typography 
            variant={isMobile ? 'h5' : isTablet ? 'h4' : 'h3'} 
            color="#fff" 
            fontWeight={700} 
            gutterBottom 
            sx={{ 
              mb: { xs: 3, sm: 4 }, 
              fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
              lineHeight: 1.2
            }}
          >
            Upgrade To "Peace Of Mind" Insurance
          </Typography>
        </Grid>
        {insurances.map((option, i) => (
          <Grid size={{xs:12, sm:6}} key={i}>
            <Card sx={{ 
              bgcolor: '#060606', 
              color: '#fff', 
              borderRadius: 3, 
              p: { xs: 2, sm: 3 }, 
              minHeight: { xs: 100, sm: 120 },
              height: '100%'
            }}>
              <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                <Typography 
                  variant="subtitle1" 
                  fontWeight={700} 
                  sx={{ 
                    fontSize: { xs: 16, sm: 18 },
                    mb: { xs: 1, sm: 1.5 }
                  }}
                >
                  {option.type} Coverage
                </Typography>
                <Typography sx={{ 
                  fontSize: { xs: 14, sm: 16 },
                  lineHeight: 1.4
                }}>
                  {option.cost} — {option.coverage}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
        <Grid size={{xs:12}}>
          <Button 
            fullWidth 
            variant="contained" 
            color="primary" 
            size="large" 
            sx={{ 
              fontWeight: 700, 
              borderRadius: 2, 
              px: { xs: 3, sm: 4 }, 
              py: { xs: 1.5, sm: 2 }, 
              fontSize: { xs: 16, sm: 18 },
              mt: { xs: 2, sm: 3 }
            }}
          >
            Reserve My Botel Now
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
